<template>
    <div class="page_msg container">
      <div class="header_gruop page_width flex_sb">
        <div class="icon_home flex_center" @click="toBack()"><svg t="1729563443244" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6080" id="mx_n_1729563443245" width="16" height="16"><path d="M398.912 513.152l377.28-384.256c27.904-28.416 27.904-74.432 0-102.784-27.84-28.352-73.024-28.352-100.8 0L247.808 461.504C233.792 475.776 226.88 494.464 226.944 513.152 226.88 531.84 233.792 550.464 247.808 564.736l427.584 435.392c27.84 28.352 73.024 28.352 100.8 0 27.904-28.352 27.904-74.368 0-102.656L398.912 513.152z" fill="#16181c" p-id="6081"></path></svg></div>
        <div class="header_title">Refund Policy</div>
        <div></div>
      </div>
  
      <div class="scoller grid_content" :v-infinite-scroll="false" style="overflow:auto">
          <div class="service page_width">
              
              <p style="font-size: 18px;font-weight: bold;margin-bottom:20px;">Refund Policy </p>
              <!-- <p style="margin-bottom:10px;">Return policy</p> -->
              <!-- <p style="margin-bottom:10px;">Any game top up that have been credited is final.</p> -->
              <p >If a customer has entered incorrect login credentials or player ID for a top-up, rgtplayhub may notify the customer via: ruiwangtrading@gmail.com</p>
              <!-- <p ></p> -->
              <p style="margin-bottom:10px;">We reserve the right to decline order fulfillment in cases such as insufficient stock or unavailability of the requested items.</p>
              <p style="margin-bottom:10px;"> To process a refund, a valid receipt or proof of purchase from rgtplayhub is required.</p>
              <!-- <p style="margin-bottom:10px;">To be eligible for a return:Unauthorized charged on your credit/debit card, Paypal or any other payment methods and your order must not be delivered</p>
              <p style="margin-bottom:10px;">We are unable to fulfill your order due to the lack of stock or unable to deliver your items due to the item is not available anymore.</p>
              <p >To complete your return, please contact our Customer Support Live-Chat or through email to </p>
              <p >ruiwangtrading@gmail.com</p>
              <p style="margin-bottom:10px;"> We require a receipt or proof of purchase in rgtplayhub for the payment to be refunded.</p>
              <p style="margin-bottom:10px;">Refunds (if applicable):If your purchase is eligible for refunds, please contact our Customer Support through email to ruiwangtrading@gmail.com</p>
              <p style="margin-bottom:10px;">Late or missing refunds (if applicable):If you haven’t received a refund yet, please check your payment accounts again.</p>
              <p style="margin-bottom:10px;">Then contact your credit card company, it may take some time before your refund is officially posted.</p>
              <p style="margin-bottom:10px;">Next contact your bank. There is often some processing time before a refund is posted.</p> -->
              <p style="margin-bottom:40px;">Eligible Refunds: If your purchase qualifies for a refund, please contact our Customer Support via email at ruiwangtrading@gmail.com.</p>
              
          </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
      methods:{
          toBack(){
              this.$router.back()
          }
      }
  }
  </script>
  
  <style>
  
  </style> 